import React, { useEffect } from 'react';
import { fireLeadNow } from '../utils/leadEvent';
const FORM_ID = 'MpGPMx8N2yjiJ8DZbGKO';
const FORM_NAME = 'Join Recruiting Page Submission';
const EMBED_SCRIPT = 'https://link.msgsndr.com/js/form_embed.js';

/** LeadConnector (GoHighLevel) inline form. The embed script auto-sizes the iframe. */
export function GhlFormEmbed() {
  useEffect(() => {
    if (!document.querySelector(`script[src="${EMBED_SCRIPT}"]`)) {
      const script = document.createElement('script');
      script.src = EMBED_SCRIPT;
      script.async = true;
      document.body.appendChild(script);
    }

    // Safety net: if the GHL form is not set to redirect to /thank-you, fire Lead
    // from the in-page submit message instead. `fireLeadNow` is session-guarded,
    // so a submit here plus a later /thank-you view still counts only one Lead.
    const trustedOrigin = /(leadconnectorhq|msgsndr|gohighlevel)\.com$/i;
    const submitSignal = /(form[-_ ]?submit|submitted|submission|thank[-_ ]?you|success)/i;
    const onMessage = (event: MessageEvent) => {
      try {
        if (!trustedOrigin.test(new URL(event.origin).hostname)) return;
      } catch {
        return;
      }
      const raw = typeof event.data === 'string' ? event.data : JSON.stringify(event.data ?? '');
      if (submitSignal.test(raw)) fireLeadNow('ghl_form_submit');
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);
  return <div className="overflow-hidden rounded-2xl bg-white p-2 md:p-3" data-id="element-115" data-mp="2koqmnm09kwly">
      <iframe src={`https://api.leadconnectorhq.com/widget/form/${FORM_ID}`} id={`inline-${FORM_ID}`} title={FORM_NAME} data-layout="{'id':'INLINE'}" data-trigger-type="alwaysShow" data-trigger-value="" data-activation-type="alwaysActivated" data-activation-value="" data-deactivation-type="neverDeactivate" data-deactivation-value="" data-form-name={FORM_NAME} data-height="undefined" data-layout-iframe-id={`inline-${FORM_ID}`} data-form-id={FORM_ID} data-cookie-consent="true" data-cookie-consent-provider="auto" className="h-[760px] w-full border-none sm:h-[700px]" data-id="element-116" data-mp="2kmnpmi0p237q" />
    </div>;
}